module.exports = __webpack_public_path__ + "static/av-94bfd7deb446d3a78713774f73c126b0.png";